class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (window.innerWidth < 749) {
        this.showMobileToast(parsedState);
      } else {
        this.open();
      }
    });
  }

  showMobileToast(parsedState) {
    let toast = document.getElementById('nf-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'nf-cart-toast';
      toast.innerHTML = `
        <style>
          #nf-cart-toast{position:fixed;bottom:-120px;left:50%;transform:translateX(-50%);width:calc(100% - 32px);max-width:420px;background:#111;color:#fff;border-radius:16px;z-index:99999;transition:bottom .38s cubic-bezier(.4,0,.2,1);box-shadow:0 8px 32px rgba(0,0,0,.45);overflow:hidden}
          #nf-cart-toast.nf-show{bottom:24px}
          .nf-ti{display:flex;align-items:center;gap:12px;padding:14px 16px}
          .nf-ti-check{width:34px;height:34px;background:#22c55e;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:18px}
          .nf-ti-txt{flex:1;min-width:0}
          .nf-ti-label{font-size:10px;color:#22c55e;font-weight:800;text-transform:uppercase;letter-spacing:1.5px;display:block;margin-bottom:2px}
          .nf-ti-name{font-size:13px;font-weight:600;display:block;line-height:1.4}
          .nf-ti-btn{background:#fff;color:#111;border:none;border-radius:10px;padding:10px 16px;font-size:12px;font-weight:800;cursor:pointer;white-space:nowrap;flex-shrink:0;letter-spacing:.5px}
          .nf-ti-bar{height:3px;background:#22c55e;animation:nfbar 3.5s linear forwards}
          @keyframes nfbar{from{width:100%}to{width:0%}}
        </style>
        <div class="nf-ti">
          <div class="nf-ti-check">✓</div>
          <div class="nf-ti-txt">
            <span class="nf-ti-label">Añadido al carrito</span>
            <span class="nf-ti-name" id="nf-toast-name"></span>
          </div>
          <button class="nf-ti-btn" id="nf-toast-btn">Ver carrito</button>
        </div>
        <div class="nf-ti-bar" id="nf-toast-bar"></div>
      `;
      document.body.appendChild(toast);
      document.getElementById('nf-toast-btn').addEventListener('click', () => {
        toast.classList.remove('nf-show');
        this.open();
      });
    }

    const productName = parsedState.title || (parsedState.items && parsedState.items[0] && parsedState.items[0].title) || 'Producto añadido';
    const countEl = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    const cartCount = parsedState.item_count || (countEl ? countEl.textContent.trim() : '');

    const nameEl = document.getElementById('nf-toast-name');
    const barEl = document.getElementById('nf-toast-bar');
    const btn = document.getElementById('nf-toast-btn');

    if (nameEl) nameEl.textContent = productName;
    if (btn) btn.textContent = cartCount ? `Ver carrito (${cartCount})` : 'Ver carrito';

    // Reset bar animation
    if (barEl) { barEl.style.animation = 'none'; barEl.offsetHeight; barEl.style.animation = ''; }

    toast.classList.add('nf-show');
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => toast.classList.remove('nf-show'), 3500);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
